import * as z from 'zod';

export const IdSchema = z.string().min(1).max(128);
export const TimestampSchema = z.string().min(1);

/**
 * Bounded scalar/reference values that may be retained as table-resolution state.
 *
 * These values intentionally cannot carry a copied datasheet, card, or rule object.
 * Player-authored prose belongs to the explicit prompt/history text fields instead.
 */
export const HordeReferenceValueSchema = z.union([z.boolean(), z.number(), z.null(), IdSchema, z.array(IdSchema)]);
export type HordeReferenceValue = z.infer<typeof HordeReferenceValueSchema>;

/** A player-entered, bounded response to a table prompt. */
export const HordePromptAnswerSchema = z.union([
    HordeReferenceValueSchema,
    z.string().min(1).max(1024),
    z.object({ confirmed: z.boolean() }).strict(),
]);
export type HordePromptAnswer = z.infer<typeof HordePromptAnswerSchema>;
